import { createPromiseAction } from "@adobe/redux-saga-promise";

export const APP_INTERNAL_SEARCH_CALL = "APP_INTERNAL_SEARCH_CALL";
export const APP_INTERNAL_SEARCH_CALL_PROMISE = "APP_INTERNAL_SEARCH_CALL_PROMISE";
export const appInternalSearchPromise = createPromiseAction(APP_INTERNAL_SEARCH_CALL_PROMISE);

export function callAppInternalSearh({ search_value, limit, offset, category, append } = {}) {
  return {
    type: APP_INTERNAL_SEARCH_CALL,
    payload: { search_value, limit, offset, category, append }
  };
}
